import { render, staticRenderFns } from "./quotes.vue?vue&type=template&id=4625118c&scoped=true&"
import script from "./quotes.vue?vue&type=script&lang=js&"
export * from "./quotes.vue?vue&type=script&lang=js&"
import style0 from "./quotes.vue?vue&type=style&index=0&id=4625118c&scoped=true&lang=css&"
import style1 from "./quotes.vue?vue&type=style&index=1&id=4625118c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4625118c",
  null
  
)

export default component.exports